import { useMemo } from 'react'

import {
  EmploymentEquipmentType,
  formatEmploymentEquipmentType,
} from 'src/graphql/types/employmentExperiences'

import { FilterOption } from '../types'

interface UseEquipmentTypesFilterProps {
  selectedEquipmentTypes: string[]
  onEquipmentTypesChange: (equipmentTypes: string[]) => void
}

export const useEquipmentTypesFilter = ({
  selectedEquipmentTypes,
  onEquipmentTypesChange,
}: UseEquipmentTypesFilterProps) => {
  const baseOptions = useMemo<FilterOption[]>(() => {
    return Object.values(EmploymentEquipmentType).map((equipmentType) => ({
      value: equipmentType,
      label: formatEmploymentEquipmentType(equipmentType),
    }))
  }, [])

  // Update options to reflect selected state
  const options = useMemo<FilterOption[]>(() => {
    return baseOptions.map((option) => ({
      ...option,
      selected: selectedEquipmentTypes.includes(option.value),
    }))
  }, [baseOptions, selectedEquipmentTypes])

  return {
    options,
    selected: selectedEquipmentTypes,
    onChange: onEquipmentTypesChange,
    isLoaded: true,
  }
}
